import { TYC } from 'constants/api'
import useAxios from 'axios-hooks'
import useMainClass from 'hooks/use-main-cass'
import LoadingScreen from 'components/loading-screen'
import styled from 'styled-components'
import { Type } from 'theme/types'
import ErrorView from 'components/error-view'
import useRouter from 'hooks/use-router'
import Breadcrumb from 'components/breadcrumb'
import styles from './styles.module.scss'

const Div = styled.div`
  ${({ theme }: Type) => theme?.termsAndConditions?.div}
`

const TYCPage = () => {
  useMainClass('terms-and-conditions')
  const { push } = useRouter()
  const [{ loading, error, data }] = useAxios({
    url: TYC,
    headers: { 'Ph-Api-Id': PH_API_ID??1 }
  })

  if (error) {
    return <ErrorView code={9999} buttonMenu={() => push('/home')} />
  }

  if (loading) {
    return <LoadingScreen />
  }

  if (data) {
    return (
      <div className='terms-container'>
        <div className='w-full pt-3'>
          <Breadcrumb 
            text='Términos y condiciones de uso'
            handleClick={() => push('/home')}
          />
        </div>
        <Div className={`${styles.wrapper} container-terms`}>
          <div dangerouslySetInnerHTML={{ __html: data }}></div>
        </Div>
      </div>
    )
  }

  return (
    <div className='terms-container'>
      <div className='w-full pt-3'>
        <Breadcrumb 
          text='Términos y condiciones de uso'
          handleClick={() => push('/home')}
        />
      </div>
      <p className='terms-not-found text-center pt-5'>Not found</p>
    </div>
  )
}

export default TYCPage
